import { render, staticRenderFns } from "./CustomClickMenu.vue?vue&type=template&id=3c59257a&scoped=true&"
import script from "./CustomClickMenu.vue?vue&type=script&lang=js&"
export * from "./CustomClickMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomClickMenu.vue?vue&type=style&index=0&id=3c59257a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c59257a",
  null
  
)

export default component.exports